import { Button } from "@4uhub/lib4uhub";
import { Box, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { IModalContentProps } from "./models";

const translationPath = "chatBot.page.service.ticketServiceArea.enableModal.";

export const ModalContent = memo(
  ({ currentValue, isEnabled, onClose, onConfirm }: IModalContentProps) => {
    const { t } = useTranslation();

    return (
      <>
        {currentValue && !isEnabled ? (
          <Typography>{t(translationPath + "disable_message")}</Typography>
        ) : (
          <Typography>{t(translationPath + "enable_message")}</Typography>
        )}
        <Box sx={{ display: "flex", justifyContent: "end", gap: 2 }}>
          <Button size="small" variant="outlined" onClick={onClose}>
            {t(translationPath + "cancel_button")}
          </Button>
          <Button size="small" variant="contained" onClick={onConfirm}>
            {t(translationPath + "confirm_button")}
          </Button>
        </Box>
      </>
    );
  }
);
